import React, { createContext, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Components/Login";
import ResetPasword from "./Components/ResetPasword";
import ResetPaswordChnage from "./Components/ResetPaswordChnage";
import {
  UserAuth,
  AdminAuth,
  SubAdminAuth,
  QualitySupervisorAuth,
} from "./Utils/Auth";
import UserDashboard from "./Components/User/UserDashboard";
import UserDevices from "./Components/User/UserDevices";
import UserChangePassword from "./Components/User/UserChangePassword";
import UserMyProfile from "./Components/User/UserMyProfile";
import UserEditProfile from "./Components/User/UserEditProfile";
import UserSurveyDetails from "./Components/User/UserSurveyDetails";
import UserSurveyParticipantsDetails from "./Components/User/UserSurveyParticipantsDetails";
import UserParticipantSurveyResponse from "./Components/User/UserParticipantSurveyResponse";
import UserListSurveys from "./Components/User/UserListSurveys";
import UserSurveyFormView from "./Components/User/UserSurveyFormView";
import UserParticipantQualificationView from "./Components/User/UserParticipantQualificationView";
import SurveyIndividualResponsesView from "./Components/User/SurveyindividualresponsesView";
import UserCreateAnalysis from "./Components/User/UserCreateAnalysis";
import UserAnalysisPreview from "./Components/User/UserAnalysisPreview";
import UserAnalysisPreviewDownload from "./Components/User/UserAnalysisPreviewDownload";
import UserAnalysisReport from "./Components/User/UserAnalysisReport";
import UserAnalysisReportDownload from "./Components/User/UserAnalysisReportDownload";
import AdminDashboard from "./Components/Admin/AdminDashboard";
import AdminListManufacturer from "./Components/Admin/AdminListManufacturer";
import AdminAddManufacturer from "./Components/Admin/AdminAddManufacturer";
import AdminListDevices from "./Components/Admin/AdminListDevices";
import AdminAddDevice from "./Components/Admin/AdminAddDevice";
import AdminListSites from "./Components/Admin/AdminListSites";
import AdminAddSite from "./Components/Admin/AdminAddSite";
import AdminListUsers from "./Components/Admin/AdminListUsers";
import AdminAddUser from "./Components/Admin/AdminAddUser";
import AdminListParticipantGroups from "./Components/Admin/AdminListParticipantGroups";
import AdminEditUser from "./Components/Admin/AdminEditUser";
import AdminAddParticipantGroup from "./Components/Admin/AdminAddParticipantGroup";
import AdminListParticipants from "./Components/Admin/AdminListParticipants";
import AdminAddParticipant from "./Components/Admin/AdminAddParticipant";
import AdminAddParticipantQualification from "./Components/Admin/AdminAddParticipantQualification";
import AdminEditParticipantQualification from "./Components/Admin/AdminEditParticipantQualification";
import AdminAddSurvey from "./Components/Admin/AdminAddSurvey";
import AdminListSurvey from "./Components/Admin/AdminListSurvey";
import AdminCreateSurveyQuestion from "./Components/Admin/AdminCreateSurveyQuestion";
import AdminSurveyDetails from "./Components/Admin/AdminSurveyDetails";
import AdminFormView from "./Components/Admin/AdminFormView";
import AdminConsentView from "./Components/Admin/AdminConsentView";
import AdminListSurveyAnalysisReport from "./Components/Admin/AdminListSurveyAnalysisReport";
import AdminListResponses from "./Components/Admin/AdminListResponses";
import AdminCreateAnalysis from "./Components/Admin/AdminCreateAnalysis";
import AdminAnalysisPreview from "./Components/Admin/AdminAnalysisPreview";
import AdminAnalysisDownload from "./Components/Admin/AdminAnalysisDownload";
import AdminParticipantQualificationView from "./Components/Admin/AdminParticipantQualificationView";
import AdminEditSurveyQuestion from "./Components/Admin/AdminEditSurveyQuestion";
import SurveyParticipantQualification from "./Components/Survey/SurveyParticipantQualification";
import SurveyConsent from "./Components/Survey/SurveyConsent";
import SurveyForm from "./Components/Survey/SurveyForm";
import SurveyNotEligible from "./Components/Survey/SurveyNotEligible";
import Survey from "./Components/Survey/Survey";
import Survey404 from "./Components/Survey/Survey404";
import SurveyThanks from "./Components/Survey/SurveyThanks";
import SurveyClosed from "./Components/Survey/SurveyClosed";
import SurveyAlreadyTaken from "./Components/Survey/SurveyAlreadyTaken";
import AdminParticipantSurveyResponse from "./Components/Admin/AdminParticipantSurveyResponse";
import AdminSurveyAnalysisReport from "./Components/Admin/AdminSurveyAnalysisReport";
import AdminSurveyAnalysisReportPreview from "./Components/Admin/AdminSurveyAnalysisReportPreview";
import AdminSurveyAnalysisReportDownload from "./Components/Admin/AdminSurveyAnalysisReportDownload";

import ManageAdministratorUser from "./Components/Admin/ManageAdministratorUser";
import AddAdministratorUser from "./Components/Admin/AddAdministratorUser";
import ManageParticipants from "./Components/Admin/ManageParticipants";
import DraftApproval from "./Components/Admin/DraftApproval";
import SurveyApproval from "./Components/Admin/SurveyApproval";
import ImportParticipants from "./Components/Admin/ImportParticipants";
import ImportData from "./Components/Admin/ImportData";

import AdminAddParticipantsAssing from "./Components/Admin/AdminAddParticipantsAssing";
import { ToastContainer } from "react-toastify";
import axios from "axios";
export const globalInfo = createContext();
function App() {
  const [ipAddress, setIpAddress] = useState("");
  const getData = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIpAddress(res.data.IPv4);
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="App">
      <globalInfo.Provider value={{ ip_address: ipAddress }}>
        <BrowserRouter>
           
          <Routes>
            <Route exact path="" element={<Login />}></Route>
            <Route exact path="*" element={<Login />}></Route>
            <Route element={<Login />}></Route>
            <Route exact path="login" element={<Login />}></Route>
            <Route
              exact
              path="account-activation/:userID/:slugToken"
              element={<ResetPasword />}
            ></Route>
            <Route
              exact
              path="reset-password/:userID/:slugToken"
              element={<ResetPaswordChnage />}
            ></Route>
            <Route
              exact
              path="UserDashboard"
              element={<UserAuth cmp={UserDashboard} />}
            ></Route>
            <Route
              exact
              path="UserListSurveys"
              element={<UserAuth cmp={UserListSurveys} />}
            ></Route>
            <Route
              exact
              path="UserDevices"
              element={<UserAuth cmp={UserDevices} />}
            ></Route>
            <Route
              exact
              path="UserChangePassword"
              element={<UserAuth cmp={UserChangePassword} />}
            ></Route>
            <Route
              exact
              path="my-profile"
              element={<UserAuth cmp={UserMyProfile} />}
            ></Route>
            <Route
              exact
              path="UserEditProfile"
              element={<UserAuth cmp={UserEditProfile} />}
            ></Route>
            <Route
              exact
              path="AdminDashboard"
              element={<SubAdminAuth cmp={AdminDashboard} />}
            ></Route>
            <Route
              exact
              path="AdminListManufacturer"
              element={<SubAdminAuth cmp={AdminListManufacturer} />}
            ></Route>
            <Route
              exact
              path="AdminAddManufacturer"
              element={<SubAdminAuth cmp={AdminAddManufacturer} />}
            ></Route>
            <Route
              exact
              path="AdminListDevices"
              element={<SubAdminAuth cmp={AdminListDevices} />}
            ></Route>
            <Route
              exact
              path="AdminAddDevice"
              element={<SubAdminAuth cmp={AdminAddDevice} />}
            ></Route>
            <Route
              exact
              path="/AdminListSites/:mID"
              element={<SubAdminAuth cmp={AdminListSites} />}
            ></Route>
            <Route
              exact
              path="AdminAddSite/:mID"
              element={<SubAdminAuth cmp={AdminAddSite} />}
            ></Route>
            <Route
              exact
              path="AdminListUsers/:mID"
              element={<SubAdminAuth cmp={AdminListUsers} />}
            ></Route>
            <Route
              exact
              path="AdminAddUser/:mID"
              element={<SubAdminAuth cmp={AdminAddUser} />}
            ></Route>
            <Route
              exact
              path="AdminEditUser/:uID"
              element={<SubAdminAuth cmp={AdminEditUser} />}
            ></Route>
            <Route
              exact
              path="AdminListParticipantGroups"
              element={<SubAdminAuth cmp={AdminListParticipantGroups} />}
            ></Route>
            <Route
              exact
              path="AdminAddParticipantGroup"
              element={<SubAdminAuth cmp={AdminAddParticipantGroup} />}
            ></Route>
            <Route
              exact
              path="AdminListParticipants/:pgID"
              element={<SubAdminAuth cmp={AdminListParticipants} />}
            ></Route>{" "}
            <Route
              exact
              path="AdminAddParticipant/:pgID"
              element={<SubAdminAuth cmp={AdminAddParticipant} />}
            ></Route>
            <Route
              exact
              path="AdminAddParticipantsAssing/:pgID"
              element={<SubAdminAuth cmp={AdminAddParticipantsAssing} />}
            ></Route>
            <Route
              exact
              path="add-survey"
              element={<SubAdminAuth cmp={AdminAddSurvey} />}
            ></Route>
            <Route
              exact
              path="survey"
              element={<SubAdminAuth cmp={AdminListSurvey} />}
            ></Route>
            <Route
              exact
              path="AdminAddParticipantQualification/:surveyID"
              element={<SubAdminAuth cmp={AdminAddParticipantQualification} />}
            ></Route>
            <Route
              exact
              path="AdminEditParticipantQualification/:surveyID"
              element={<SubAdminAuth cmp={AdminEditParticipantQualification} />}
            ></Route>
            <Route
              exact
              path="AdminCreateSurveyQuestion/:surveyID"
              element={<SubAdminAuth cmp={AdminCreateSurveyQuestion} />}
            ></Route>
            <Route
              exact
              path="AdminSurveyDetails/:surveyID"
              element={<SubAdminAuth cmp={AdminSurveyDetails} />}
            ></Route>
            <Route
              exact
              path="AdminFormView/:surveyID"
              element={<SubAdminAuth cmp={AdminFormView} />}
            ></Route>
            <Route
              exact
              path="AdminConsentView/:surveyID"
              element={<SubAdminAuth cmp={AdminConsentView} />}
            ></Route>
            <Route
              exact
              path="AdminListSurveyAnalysisReport"
              element={<SubAdminAuth cmp={AdminListSurveyAnalysisReport} />}
            ></Route>
            <Route
              exact
              path="AdminListResponses/:surveyID"
              element={<SubAdminAuth cmp={AdminListResponses} />}
            ></Route>
            <Route
              exact
              path="AdminCreateAnalysis/:surveyID"
              element={<SubAdminAuth cmp={AdminCreateAnalysis} />}
            ></Route>
            <Route
              exact
              path="AdminAnalysisPreview/:surveyID/:questionID/:questionNo"
              element={<AdminAnalysisPreview />}
            ></Route>
            <Route
              exact
              path="AdminAnalysisDownload/:surveyID/:questionID/:questionNo"
              element={<AdminAnalysisDownload />}
            ></Route>
            <Route
              exact
              path="AdminSurveyAnalysisReportDownload/:surveyID"
              element={<AdminSurveyAnalysisReportDownload />}
            ></Route>
            <Route
              exact
              path="AdminParticipantQualificationView/:surveyID"
              element={<SubAdminAuth cmp={AdminParticipantQualificationView} />}
            ></Route>
            <Route
              exact
              path="AdminEditSurveyQuestion/:surveyID"
              element={<SubAdminAuth cmp={AdminEditSurveyQuestion} />}
            ></Route>
            <Route
              exact
              path="AdminParticipantSurveyResponse/:surveyID/:participantID"
              element={<SubAdminAuth cmp={AdminParticipantSurveyResponse} />}
            ></Route>
            <Route
              exact
              path="AdminSurveyAnalysisReport/:surveyID"
              element={<SubAdminAuth cmp={AdminSurveyAnalysisReport} />}
            ></Route>
            <Route
              exact
              path="AdminSurveyAnalysisReportPreview/:surveyID"
              element={<SubAdminAuth cmp={AdminSurveyAnalysisReportPreview} />}
            ></Route>
            <Route
              exact
              path="SurveyParticipantQualification/:formKey"
              element={<SurveyParticipantQualification />}
            ></Route>
            <Route
              exact
              path="SurveyConsent/:formKey"
              element={<SurveyConsent />}
            ></Route>
            <Route
              exact
              path="SurveyForm/:formKey"
              element={<SurveyForm />}
            ></Route>
            <Route
              exact
              path="SurveyNotEligible"
              element={<SurveyNotEligible />}
            ></Route>
            <Route exact path="Survey404" element={<Survey404 />}></Route>
            <Route exact path="Survey/:formKey" element={<Survey />}></Route>
            <Route exact path="SurveyThanks" element={<SurveyThanks />}></Route>
            <Route exact path="SurveyClosed" element={<SurveyClosed />}></Route>
            <Route
              exact
              path="survey-already-taken"
              element={<SurveyAlreadyTaken />}
            ></Route>
            <Route
              exact
              path="UserSurveyDetails/:surveyID"
              element={<UserAuth cmp={UserSurveyDetails} />}
            ></Route>
            <Route
              exact
              path="UserSurveyParticipantsDetails/:surveyID"
              element={<UserAuth cmp={UserSurveyParticipantsDetails} />}
            ></Route>
            <Route
              exact
              path="survey-form/participant-survey/:surveyID/:participantID"
              element={<UserAuth cmp={UserParticipantSurveyResponse} />}
            ></Route>
            <Route
              exact
              path="survey-form/preview/:surveyID"
              element={<UserAuth cmp={UserSurveyFormView} />}
            ></Route>
            <Route
              exact
              path="survey-form/participant-qualification/:surveyID"
              element={<UserAuth cmp={UserParticipantQualificationView} />}
            ></Route>
            <Route
              exact
              path="survey-individual-responses/:surveyID"
              element={<UserAuth cmp={SurveyIndividualResponsesView} />}
            ></Route>
            <Route
              exact
              path="manufacturer-create-analysis/:surveyID"
              element={<UserAuth cmp={UserCreateAnalysis} />}
            ></Route>
            <Route
              exact
              path="manufacturer/analysis/preview/:surveyID/:questionID/:questionNo"
              element={<UserAuth cmp={UserAnalysisPreview} />}
            ></Route>
            <Route
              exact
              path="manufacturer/reports/preview_download/:surveyID/:questionID/:questionNo"
              element={<UserAuth cmp={UserAnalysisPreviewDownload} />}
            ></Route>
            <Route
              exact
              path="manufacturer/reports/analysis_report/:surveyID"
              element={<UserAuth cmp={UserAnalysisReport} />}
            ></Route>
            <Route
              exact
              path="manufacturer/reports/analysis_report_download/:surveyID"
              element={<UserAuth cmp={UserAnalysisReportDownload} />}
            ></Route>
            <Route
              exact
              path="ManageAdministratorUser"
              element={<AdminAuth cmp={ManageAdministratorUser} />}
            ></Route>
            <Route
              exact
              path="AddAdministratorUser"
              element={<AdminAuth cmp={AddAdministratorUser} />}
            ></Route>
            <Route
              exact
              path="manage-participants"
              element={<UserAuth cmp={ManageParticipants} />}
            ></Route>
            <Route
              exact
              path="import-participants"
              element={<SubAdminAuth cmp={ImportParticipants} />}
            ></Route>
            <Route
              exact
              path="admin/imports"
              element={<AdminAuth cmp={ImportData} />}
            ></Route>
            <Route
              exact
              path="qa/survey-form/preview/:surveyID"
              element={<UserAuth cmp={UserSurveyFormView} />}
            ></Route>
            <Route
              exact
              path="qa/manufacturer/reports/analysis_report/:surveyID"
              element={<UserAuth cmp={UserAnalysisReport} />}
            ></Route>
            <Route
              exact
              path="/survey-draft-approval"
              element={<UserAuth cmp={DraftApproval} />}
            ></Route>
            <Route
              exact
              path="/survey-analysis-report-approval"
              element={<UserAuth cmp={SurveyApproval} />}
            ></Route>
            <Route
              exact
              path="/admin/import-participants"
              element={<SubAdminAuth cmp={ImportParticipants} />}
            ></Route>
          </Routes>
          <ToastContainer/>
        </BrowserRouter>
      </globalInfo.Provider>
    </div>
  );
}

export default App;
